<template>
    <v-container max-width="100%" style="margin-top: 2%;">
        <template>
            <v-row justify="center">
                <v-dialog v-model="confirmDialog" persistent max-width="500">
                    <v-card>
                        <v-card-title class="headline">
                            <span style="color: #d60000">{{ $t('system.alert') }}</span>
                        </v-card-title>
                        <v-card-text>
                            <span style="color: #d60000">{{ this.mensagemdialog }}</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{
                                messageDismissButton }}</v-btn>
                            <v-btn v-if="showConfirmButton" color="red accent-4" class="white--text"
                                @click="deleteFromDatabase">{{ this.messageConfirmButton }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <merus-data-table :headers="headers" :items="grupos" mostrar-inativos :loading="loadingtable" :default-multi-sort="defaultSort"
            :loading-text="$t('groups.loading')" :server-items-length="totalGrupos" :items-per-page="numberOfRows"
            :items-per-page-last-option="itemsPerPageLastOption" :server-sort-by="serverSortBy" :server-sort-desc="serverSortDesc"
            @update:options="onTableOptions" @update:filters="onFiltersUpdate" item-key="id_grupo"
            cod-tabela="GRUPOS" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('groups.title')" :token="token" :items="[]" :load-items-for-export="loadItemsForExport" background-export
                    :export-filters="searchFilters" :export-sort-by="serverSortBy" :export-sort-desc="serverSortDesc" :export-total="totalGrupos"
                    :csv-title="$t('groups.title')"
                    :pdf-title="$t('nav.registration.groups')" :pdf-headers="headers" :pdf-filename="$t('groups.title')" hide-search
                    :endpoint-upload-csv="canEdit || canInsert ? '/api/v1.0/processacsvgrupos/' : null" @saveBulk="saveBulk"
                    :help-dialog-csv-fields="helpCSV" :help-dialog-csv-model="$t('groups.title')" :csv-headers="headersCSV">
                    <template v-slot:extension>
                        <v-switch
                            v-model="mostrarInativos"
                            :label="$t('crudVeiculos.showInactive')"
                            class="ml-3 mr-4"
                            hide-details
                        ></v-switch>
                    </template>
                    <template v-slot:add v-if="canInsert">
                        <v-dialog v-model="dialog" max-width="100%">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-toolbar dark color="primary" ref="myToolbar">
                                    <v-btn icon dark @click="close">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-toolbar-items>
                                        <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                                    </v-toolbar-items>
                                </v-toolbar>

                                <v-card-text>
                                    <v-container>
                                        <v-form ref="form" v-model="formValidado">
                                            <v-row>
                                                <v-col cols="12" sm="6" md="5">
                                                    <v-text-field v-model="editedItem.nome"
                                                        :label="$t('groups.fields.name')"></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="3" md="2">
                                                    <v-text-field v-model="editedItem.qtd_acessos"
                                                        :label="$t('groups.fields.access_quantity')" min="0"
                                                        hide-spin-buttons></v-text-field>
                                                </v-col>

                                                <v-col cols="12" sm="3" md="1">
                                                    <v-switch v-model="editedItem.ativo" class="ma-2"
                                                        :label="$t('groups.fields.active')"></v-switch>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="12">
                                                    <v-select v-model="editedItem.id_cliente" :items="clientes"
                                                        item-text="nome_cliente" item-value="id_cliente" single-line
                                                        auto clearable :label="$t('groups.fields.client')"
                                                        :disabled="isClienteSelectDisabled">
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="12">
                                                    <v-select v-model="editedItem.id_grupo_matriz" :items="matriz"
                                                        item-text="nome" item-value="id_grupo" single-line auto
                                                        clearable :label="$t('groups.fields.matrix_group')"
                                                        @change="onMatrizChanged">
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="12">
                                                    <MultiplaEscolha lazy get-url="getRotaslazy" :items="rotasGrupoItens"
                                                        text="nome_rota" value="id_rota"
                                                        v-bind:selected-items.sync="rotasGrupo"
                                                        :label="$t('groups.fields.routes')"
                                                        :hint="$t('groups.fields.routes_hint')" persistent-hint
                                                        :disabled="loadingRotasGrupo" />
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </template>
                </CadastroToolbar>

            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
                <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
            </template>
        </merus-data-table>
    </v-container>
</template>

<script>

    import apiController from "@/utils/apiController";
    import { validador } from "@/constants";
    import MerusDataTable from "./Tables/MerusDataTable.vue";
    import CadastroToolbar from "./Toolbars/CadastroToolbar.vue";
    import MultiplaEscolha from "./Selects/MultiplaEscolha.vue";
    import EventBus from '../utils/eventBus';
    import { getScopedClienteIdForCreate, shouldLockClienteOnCreate } from "@/utils/sessionCliente";
    import serverTableMixin from "@/mixins/serverTableMixin";
    import {
        buildRequestParams,
        computePageState,
        initSortFromDefault,
        fetchAllServerPagesForExport,
    } from "@/utils/serverTablePagination";

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        MultiplaEscolha
    },
    mixins: [serverTableMixin],
    data: () => ({
    headers: [],
        messageDismissButton: null,
        grupos: [],
        mostrarInativos: false,
        totalGrupos: 0,
        numberOfRows: 10,
        itemsPerPageLastOption: 1000,
        lastItemsPerPageBeforeTodos: null,
        pageNumber: 1,
        serverSortBy: [],
        serverSortDesc: [],
        searchFilters: {},
        matriz: [],
        clientes: [],
        rotasGrupo: [],
        rotasGrupoItens: [],
        search: "",
        loadingtable: true,
        loadingRotasGrupo: false,
        tipoAlerta: "success",
        showAlert: false,
        mensagemAlerta: "",
        confirmDialog: false,
        mensagemdialog: "",
        showConfirmButton: true,

        authDialog: false,
        formValidado: true,
        dialog: false,
        sysError: null,
        editedIndex: -1,
        payload: {},
        grupoMatriz: {
            id_grupo: null,
            nome: null,
            id_cliente: null,
            nome_cliente: null,
            id_grupo_matriz: null,
            qtd_acessos: null,
            total_pessoas_associadas: 0,
            ativo: 1,
        },
        editedItem: {
            id_grupo: null,
            nome: null,
            id_cliente: null,
            nome_cliente: null,
            id_grupo_matriz: null,
            qtd_acessos: null,
            total_pessoas_associadas: 0,
            ativo: 1,
        },
        deletedItem: {
            id_grupo: null,
            nome: null,
            id_cliente: null,
            nome_cliente: null,
            id_grupo_matriz: null,
            qtd_acessos: null,
            total_pessoas_associadas: 0,
            ativo: 1,
        },
        defaultItem: {
            id_grupo: null,
            nome: null,
            id_cliente: null,
            cliente_extenso: null,
            nome_cliente: null,
            qtd_acessos: null,
            total_pessoas_associadas: 0,
            ativo: 1,
        },
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? this.$t('groups.dialog.create') : this.$t('groups.dialog.edit');
        },
        defaultSort() {
            return [
                { value: 'ativo_extenso', options: { text: this.$t('routs.decreasing'), value: -1 } },
                { value: 'nome', options: { text: this.$t('routs.increasing'), value: 1 } }];
        },
        messageConfirmButton() {
            return this.$t('button.confirm');
        },
    headersCSV() {
            return [
                { text: this.$t('csv.lineNumber'), value: 'line_number', error: 'error_line' },
                { text: this.$t('crudVeiculos.csvHeaders.operacao'), value: 'operacao' },
                { text: this.$t('groups.headers.name'), value: 'nome' },
                { text: this.$t('groups.headers.client'), value: 'nome_cliente' },
                { text: this.$t('groups.headers.total_accesses'), value: 'qtd_acessos' },
                { text: this.$t('groups.headers.matrix_group'), value: 'nome_grupo_matriz' },
                { text: this.$t('groups.headers.active'), value: 'ativo' },
                { text: this.$t('groups.headers.routes'), value: 'cod_rotas' }];
        },
        helpCSV() {
            return [
                { label: this.$t('groups.headers.name'), description: this.$t('groups.headers.name_description'), example: "Grupo 1", key: "nome" },
                { label: this.$t('groups.headers.client'), description: this.$t('groups.headers.client_description'), example: "Cliente 1", key: "nome_cliente" },
                { label: this.$t('groups.headers.total_accesses'), description: this.$t('groups.headers.total_accesses_description'), example: "10", key: "qtd_acessos" },
                { label: this.$t('groups.headers.matrix_group'), description: this.$t('groups.headers.matrix_group_description'), example: "Grupo Matriz 1", key: "nome_grupo_matriz" },
                { label: this.$t('groups.headers.active'), description: this.$t('groups.headers.active_description'), example: "1", key: "ativo" },
                { label: this.$t('groups.headers.routes'), description: this.$t('groups.headers.routes_description'), example: "01 - xxxxx | 02 - xxxxx", key: "cod_rotas" }
            ];
        },
        nomeGrupoRules() {
            if (!validador(this.editedItem.nome_rota, 1, 200, 1, 1)) {
                return this.$t('groups.fields.name_hint');
            } else {
                return true;
            }
        },
        isClienteSelectDisabled() {
            return this.editedIndex === -1 && shouldLockClienteOnCreate();
        },
    },
    watch: {
        mostrarInativos() {
            this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
            this.pageNumber = 1;
            this.serverTableLoad();
        },
        dialog(val) {
            if (val && this.editedIndex === -1) {
                const scopedId = getScopedClienteIdForCreate();
                if (scopedId != null) {
                    this.editedItem.id_cliente = scopedId;
                }
            }
        },
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
    },
    methods: {

        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updategrupo");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/creategrupo");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletegrupo");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            if (this.serverSortBy.length === 0 && this.defaultSort && this.defaultSort.length > 0) {
                const { serverSortBy, serverSortDesc } = initSortFromDefault(this.defaultSort);
                this.serverSortBy = serverSortBy;
                this.serverSortDesc = serverSortDesc;
            }
            this.searchFilters = Object.assign({}, this.serverTableBaseFilters(), this.columnFiltersOnly());
            this.serverTableLoad();
            this.populaMatriz();
            this.populaClientes();
        },
        serverTableBaseFilters() {
            return this.mostrarInativos ? {} : { somente_ativos: '1' };
        },
        columnFiltersOnly() {
            const out = Object.assign({}, this.searchFilters);
            delete out.somente_ativos;
            return out;
        },
        serverTableLoad(options) {
            const state = {
                pageNumber: this.pageNumber,
                numberOfRows: this.numberOfRows,
                serverSortBy: this.serverSortBy,
                serverSortDesc: this.serverSortDesc,
                searchFilters: this.searchFilters,
                lastItemsPerPageBeforeTodos: this.lastItemsPerPageBeforeTodos,
                total: this.totalGrupos,
            };
            const { params, page, rowsPerPage, sortByArr, sortDescArr } = buildRequestParams(options, state);
            this.loadingtable = true;
            apiController.request(apiController.endpoints.getallGrupos, {
                data: params,
                onSuccess: (response) => {
                    const data = response.data;
                    const updates = computePageState(
                        { items: data.items, total: Number(data.total) },
                        { page, rowsPerPage, sortByArr, sortDescArr },
                        state,
                        this.itemsPerPageLastOption
                    );
                    this.grupos = data.items;
                    this.totalGrupos = updates.total;
                    this.pageNumber = updates.pageNumber;
                    this.numberOfRows = updates.numberOfRows;
                    this.lastItemsPerPageBeforeTodos = updates.lastItemsPerPageBeforeTodos;
                    this.serverSortBy = updates.serverSortBy;
                    this.serverSortDesc = updates.serverSortDesc;
                    this.loadingtable = false;
                },
                onError: () => {
                    this.loadingtable = false;
                },
            });
        },
        loadItemsForExport(onProgress) {
            return fetchAllServerPagesForExport({
                fetchPage: async (params) => {
                    const response = await apiController.request(
                        apiController.endpoints.getallGrupos,
                        { data: params, silent: true },
                    );
                    return response && response.data;
                },
                state: {
                    total: this.totalGrupos,
                    serverSortBy: this.serverSortBy,
                    serverSortDesc: this.serverSortDesc,
                    searchFilters: this.searchFilters,
                },
                onProgress,
            });
        },
        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.deletedItem = Object.assign({}, this.defaultItem);
                this.grupoMatriz = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.rotasGrupo = [];
                this.rotasGrupoItens = [];
            });
        },
        populaClientes() {
            apiController.request(apiController.endpoints.getallClientes, {
                onSuccess: (response) => {
                    this.clientes = response.data;
                },
            });
        },
        populaMatriz() {
            apiController.request(apiController.endpoints.getGruposmatriz, {
                    onSuccess: (response) => {
                        this.matriz = response.data;
                    },
                });
            },
            populaRotasGrupo(){
                this.loadingRotasGrupo = true;
                apiController.request(apiController.endpoints.getRotasporgrupo, {
                    data: [this.editedItem.id_grupo],
                    onSuccess: (response) => {
                        this.rotasGrupoItens = response.data;
                        this.rotasGrupo = response.data.map((r) => r.id_rota);
                        this.loadingRotasGrupo = false;
                    },
                    onError: () => {
                        this.loadingRotasGrupo = false;
                    },
                });
            },
            editItem(item){
                this.editedIndex = this.grupos.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.grupoMatriz = Object.assign({}, this.matriz.find((g) => g.id_grupo === this.editedItem.id_grupo_matriz));
                this.populaRotasGrupo();
                this.operacao = 1;
                this.dialog = true;
            },
            deleteItem(item){
                this.deletedItem = Object.assign({}, item);
                this.operacao = 2;
                if (this.deletedItem.total_pessoas_associadas > 0) {
                    this.mensagemdialog = this.$t('groups.error.filled_accesses');
                    this.messageDismissButton = this.$t('button.cancel'); 
                    this.showConfirmButton = false;
                } else {
                    this.mensagemdialog = this.$t('groups.confirmation.delete', { name: this.deletedItem.nome })
                    this.messageConfirmButton = this.$t('button.delete');
                    this.messageDismissButton = this.$t('button.cancel'); 
                    this.showConfirmButton = true;
                }
                this.confirmDialog = true;
            },
            deleteFromDatabase(){
                apiController.request(apiController.endpoints.deleteGrupo, {
                    data: this.deletedItem,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                        this.confirmDialog = false;
                    },
                    onError: () => {
                        this.confirmDialog = false;
                    },
                });
            },
            save(){
                this.$refs.form.validate();
                if (this.formValidado) {
                    this.editedItem.cod_integracao_grupo_matriz = this.grupoMatriz.cod_integracao_faceid || '2';
                    if (this.editedIndex == -1) {
                        this.operacao = 0;

                    apiController.request(apiController.endpoints.createGrupo, {
                        data: this.editedItem,
                        onSuccess: (response) => {
                            console.log(response.data);
                            this.populaMatriz();
                            // Handle both response formats: insertId or idgrupo (when Hikvision is enabled)
                            const idGrupo = response.data.insertId || response.data.idgrupo;
                            if (idGrupo) {
                                this.associaRotasGrupo(idGrupo);
                            } else {
                                EventBus.$emit('show-error', { error: { message: 'Failed to get group ID from server response' } });
                            }
                        },
                    });
                } else {
                    this.operacao = 1;
                    apiController.request(apiController.endpoints.updateGrupo, {
                        data: this.editedItem,
                        onSuccess: (response) => {
                            console.log(response.data);
                            this.desassociaRotasGrupo();
                            this.populaMatriz();
                        },
                    });
                    }
                }
            },
            associaRotasGrupo(idgrupo) {
                if (!idgrupo) {
                    console.error('Cannot associate routes: id_grupo is missing');
                    EventBus.$emit('show-error', { error: { message: 'Group ID is missing. Cannot associate routes.' } });
                    this.updateTable(true);
                    return;
                }
                if (this.rotasGrupo.length > 0) {
                    let body = this.rotasGrupo.map((r) => {
                        return [idgrupo, r];
                    });
    
                    apiController.request(apiController.endpoints.associaRotasbulk, {
                        data: body,
                        silent: true,
                        onSuccess: (response) => {
                            console.log(response.data);
                            this.updateTable(response.data.erro);
                        },
                        onError: (e) => {
                            console.log(e);
                            this.sysError = e;
                            this.authDialog = true;
                        },
                    });
                } else {
                    this.updateTable(false);
                }
            },
            desassociaRotasGrupo() {
                apiController.request(apiController.endpoints.desassociaRotasbulk, {
                    data: { idgrupo: this.editedItem.id_grupo },
                    onSuccess: (response) => {
                        if (this.rotasGrupo.length > 0) {
                            this.associaRotasGrupo(this.editedItem.id_grupo);
                        } else {
                            this.updateTable(response.data.erro);
                        }
                    },
                });
            },
            updateTable(status) {
                if (status) {
                    if (this.operacao == 0) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('groups.error.create'), tipo: 'error' });
                    } else {
                    if (this.operacao == 1) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('groups.error.update'), tipo: 'error' });
                    }else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('groups.error.delete'), tipo: 'error' });
                    }
                    }
                } else {
                    if (this.operacao == 0) {
                    EventBus.$emit('show-alert', { mensagem: this.$t('groups.alerts.success.create'), tipo: 'success' });
                    } else {
                    if (this.operacao == 1) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('groups.alerts.success.update'), tipo: 'success' });
                    } 
                    if(this.operacao == 2) {
                        EventBus.$emit('show-alert', { mensagem: this.$t('groups.alerts.success.delete'), tipo: 'success' });
                    }
                    else {
                        EventBus.$emit('show-alert', { mensagem: this.$t('groups.alerts.success.insert_bulk'), tipo: 'success' });
                    }
                }
                }
                this.close();
                this.initialize();
            },
            onMatrizChanged() {
                this.grupoMatriz = Object.assign({}, this.matriz.find((g) => g.id_grupo === this.editedItem.id_grupo_matriz));
            },
            saveBulk(result) {
                this.operacao = 3;
                apiController.request(apiController.endpoints.upsertGruposbulk, {
                    data: result,
                    onSuccess: (response) => {
                        this.updateTable(response.data.erro);
                    },
                });
            },
        },
    }
</script>